export default {
  feedback: {
    tooltips: {
      rateUs: 'A screenshot will help us better understand the issue.',
    },
    rateUsInfo: {
      rateUsInfoDescription:
        'Thanks to feedback from our users, hubmee is constantly improving! Your opinion is critical to us. Please rate the hubmee system fairly.',
      rateUsInfoCategories: {
        idea: 'Idea',
        design: 'Design',
        functionality: 'Functionality',
      },
    },
    supportUsInfo: {
      supportUsInfoDescription:
        'Got a problem? We will be happy to answer any of your questions! Contact hubmee support chat.',
    },
  },
};
